import { state } from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const questionnaire = {
  state,
  actions,
  getters,
  mutations,
};

export default questionnaire;
